import type { FeatureCollection, Feature, Polygon, MultiPolygon } from 'geojson';
import type { Entity } from '@/modules/pipelines/model/entity';

export type RegionFC = FeatureCollection<Polygon | MultiPolygon>;

export const emptyRegionsGeoJson: RegionFC = {
  type: 'FeatureCollection',
  features: [],
};

function isRegionGeometry(g?: Entity['geometry']): g is Polygon | MultiPolygon {
  return g?.type === 'Polygon' || g?.type === 'MultiPolygon';
}

const REGION_PALETTE = [
  '#2563eb',
  '#a855f7',
  '#0d9488',
  '#ea580c',
  '#dc2626',
  '#16a34a',
  '#d97706',
  '#0891b2',
  '#db2777',
  '#4f46e5',
];

// This is temporary, we need to find a way of picking colors for each region/state/basin... etc.
const REGION_COLORS: Record<string, string> = {
  'region:new-england': REGION_PALETTE[0],
  'region:atlantic-seaboard': REGION_PALETTE[1],
  'region:midwest': REGION_PALETTE[2],
  'region:midcontinent': REGION_PALETTE[3],
  'region:northeast': REGION_PALETTE[4],
  'region:gulf-coast': REGION_PALETTE[5],
  'region:pacific-northwest': REGION_PALETTE[6],
  'region:rockies': REGION_PALETTE[7],
  'region:west': REGION_PALETTE[8],
  'region:southeast': REGION_PALETTE[9],
};

function colorForId(id: string): string {
  const known = REGION_COLORS[id];
  if (known) return known;

  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0;
  return REGION_PALETTE[Math.abs(hash) % REGION_PALETTE.length];
}

export function entitiesToRegionsGeoJson(entities: Entity[]): RegionFC {
  const kept = entities.filter(e => isRegionGeometry(e.geometry));
  const features: Feature<Polygon | MultiPolygon>[] = kept.map(e => ({
    type: 'Feature',
    geometry: e.geometry as Polygon | MultiPolygon,
    properties: { id: e._id, name: e.name, color: colorForId(e._id) },
  }));

  return { type: 'FeatureCollection', features };
}
